import React, { useEffect } from 'react';

const Ads = props => {
    const { slot } = props;

    useEffect(() => {
        window.adsbygoogle = window.adsbygoogle || [];
        window.adsbygoogle.push({});
        // eslint-disable-next-line
    }, [slot]);

    return (
        <div key={slot} className={`${props.classes}`}>
            <ins className="adsbygoogle"
                style={{ display: 'block' }}
                data-ad-client="ca-pub-6104650385157277"
                data-ad-slot={props.slot}
                data-ad-format="auto"
                data-full-width-responsive="true">
            </ins>
        </div>
    );
}
export default Ads;